import { of } from 'rxjs'
import { useObservableStream, useObservableFromState } from './rx-hooks'
import { delay, switchMap } from 'rxjs/operators'

/**
 * Hook that delays flipping to `true` for subsequent loads.
 * This is useful to prevent loaders from displaying if the
 * reload finishes quickly.
 *
 * @param isLoading
 * @param ms
 * @param deps
 */
export function useLoading(
  isLoading: boolean,
  ms = 200,
  deps: readonly unknown[] = [],
) {
  const isLoading$ = useObservableFromState(isLoading)
  return useObservableStream(
    isLoading,
    () =>
      isLoading$.pipe(
        switchMap((loading, index) => {
          if (index === 0 || !loading) {
            return of(loading)
          }

          return of(true).pipe(delay(ms))
        }),
      ),
    [ms, ...deps],
  )
}
